import EntryReportContainer from "../../../Component/Application/entries-reporting/entry-report-container";

const EntryReportingPage = () => {

    return (
        <div className="page-body">
            <EntryReportContainer />    
        </div>
    );

};
export default EntryReportingPage;